// extracted by mini-css-extract-plugin
module.exports = {"container":"e_jC","hoverContainer":"e_kC","tooltip":"e_lC","active":"e_mC","head":"e_nC","text":"e_oC"};